import { createStore, setStateHelper } from "@neonumy/neonumy-ui";
import { StoreApi, UseBoundStore } from "zustand";

interface UserData {
  listCycles: Cycle[];
  currentCycleId: ID;
  resetStore: () => void;
  setListCycles: (listCycles: Cycle[]) => void;
  setCurrentCycle: (currentCycleId?: ID) => void;
  updateListCycle: ({ item }: { item: Cycle }) => void;
}

const initialState = {
  listCycles: [],
};

const useGlobalStore: UseBoundStore<StoreApi<UserData>> = createStore<UserData>(
  (set: (fn: (draft: Record<string, any>) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setListCycles: (listCycles: Cycle[]) => {
      setStateHelper("listCycles", listCycles, set);
    },
    setCurrentCycle: (currentCycleId: ID) => {
      setStateHelper("currentCycleId", currentCycleId, set);
    },
    updateListCycle: ({ item }: { item: Cycle }) => {
      set(state => {
        const listCycles = state.listCycles.map(cycle => {
          if (cycle.id === item.id) {
            return {
              ...item,
            };
          }

          return cycle;
        });

        return { listCycles };
      });
    },
  }),
);

export default useGlobalStore;
